export default {
  colors: {
    primary: "#1e7cf7",
    background: "#FFFFFF",
    shape: `#F2F2FA`,
    text: `#282c34`,
    title: `##20232a`,
  },
}
